
  import { css } from 'lit';
  export const styles = css`:host{--active-background: var(--ig-highlight-active-background, var(--ig-primary-500));--active-color: var(--ig-highlight-active-color, var(--ig-primary-500-contrast));--ig-theme: indigo;--ig-theme-variant: light}`;
  